import styled from 'styled-components';
import withIsMobile from '../../../context/withIsMobile';

const Grow = withIsMobile(styled.div`
  flex-grow: ${props => (props.fullWidthSection ? 0 : 1)};
  min-width: ${props => (props.isMobile ? 20 : 50)}px;
`);

export default Grow;



// WEBPACK FOOTER //
// ./src/components/MessageHistory/BotMessage/Grow.js